import { render, staticRenderFns } from "./ItemElement.vue?vue&type=template&id=6fb35fd7&"
import script from "./ItemElement.vue?vue&type=script&lang=js&"
export * from "./ItemElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports